import { Rating } from '@mui/material'
import React from 'react'

export default function HeaderCursos({selectedCurso}) {
    return (
        <div style={{height: '120px', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
            <div style={{ display: 'flex' }}>

               {/*  <Rating name="half-rating" defaultValue={3.83} precision={0.5} />
                <h3>3.83(12 Avaliações)</h3> */}
            </div>
            <h2>{selectedCurso?.titulo}</h2>
            <h3>Categorias: {selectedCurso?.area}</h3>
        </div>
    )
}
